module.exports = __webpack_public_path__ + "img/l.0fc3bb04.jpg";